import React from 'react'
import clsx from 'clsx'
import { Navbar, Dropdown, Nav, Image, Container } from 'react-bootstrap'
import { Link, useLocation, NavLink } from 'react-router-dom'

import { NavDropdown } from '../components/controls'
import routes from '../core/constants/routes'
import useAction from './useAction'
import LogoIcon from '../assets/images/logo.svg'
import useAppContext from '../components/app'

const { INVOICES, ESTIMATES, WORKFLOW, ACCOUNTSETTING, MANAGEUSERS, ADAS_REPORTS } = routes

const NavigationDesktop = () => {
	const { store: { clientPortalUser, clientSettings, featureFlags } } = useAppContext()
	const actions = useAction()
	const location = useLocation()
	const { pathname = '' } = location

	const { admin = false } = clientPortalUser

	return (
		<Container>
			<Navbar className='fw-bold text-uppercase p-0 navigate-desktop'>
				<Navbar.Brand>
					<Link to='/'>
						<Image src={LogoIcon} />
					</Link>
				</Navbar.Brand>

				<Nav className='ms-auto nav-drop-down'>
					{featureFlags?.adasReports && clientSettings && clientSettings.vehicleReports && clientSettings.vehicleReports.allowView && (
						<NavLink
							to={ADAS_REPORTS}
							className={clsx('fs-small text-dark mx-4 py-4', {
								'border-bottom text-primary border-primary border-3': pathname.startsWith(ADAS_REPORTS),
							})}
						>
							ADAS Reports
						</NavLink>
					)}
					<NavLink
						to={ESTIMATES}
						className={clsx('fs-small text-dark mx-4 py-4', {
							'border-bottom text-primary border-primary border-3': pathname === ESTIMATES,
						})}
					>
						Estimates
					</NavLink>
					<NavLink
						to={INVOICES}
						className={clsx('fs-small text-dark mx-4 py-4', {
							'border-bottom text-primary border-primary border-3': pathname === INVOICES,
						})}
					>
						Invoices
					</NavLink>
					<NavLink
						to={WORKFLOW}
						className={clsx('fs-small text-dark mx-4 py-4', {
							'border-bottom text-primary border-primary border-3': pathname === WORKFLOW,
						})}
					>
						VEHICLES
					</NavLink>
				</Nav>
				<Nav>
					<NavDropdown
						className='mx-4 py-3 fs-small border-bottom border-white'
						title={`${clientPortalUser?.firstName} ${clientPortalUser?.lastName}`}
						position='right'
					>
						<Dropdown.Item as={Link} to={ACCOUNTSETTING} className='text-capitalize text-dark'>
							Account Settings
						</Dropdown.Item>
						{admin && (
							<Dropdown.Item as={Link} to={MANAGEUSERS} className='text-capitalize text-dark'>
								Manage Users
							</Dropdown.Item>
						)}
						<Dropdown.Item className='text-capitalize' onClick={actions.logout}>
							Log out
						</Dropdown.Item>
						<Dropdown.Item
							as='a'
							target='_blank'
							rel='noreferrer'
							href='https://www.mobiletechrx.com/contact-us/'
							className='text-dark'
						>
							Help
						</Dropdown.Item>
					</NavDropdown>
				</Nav>
			</Navbar>
		</Container>
	)
}

export default NavigationDesktop
